import {useEffect, useState} from "react";
import ApiService from "../../core/service/ApiService";
import {Select} from "antd";

export default function FirmSelectList({all,...props}) {
    const [firms, setFirms] = useState([])

    const getFirms = async () => {
        const res = await ApiService.Firm.GetFirmList(all || false)
        if(res.success) {
            setFirms(res.data)
        }
    }

    useEffect(() => {
        getFirms()
    }, []);

    return (
        <Select
            {...props}
        >
            {
                firms.map(f => (
                    <Select.Option value={f.id}>
                        {f.name}
                    </Select.Option>
                ))
            }
        </Select>
    )
}